const PartInformation = {
    pl: "prolook",

    QX7: "qx7",
    CUSTOMIZER_BACKEND: "customizer_backend",

    setupPartInformation: function(labels, settings) {
        let part_info = [];
        let teamColors = this.colorExtractor(ub.current_material.settings.team_colors);

        _.each(labels, label => {
            let part = {
                part: label.name,
                type: "color",
                // Fabric Information
                fabric: {
                    id: 0,
                    name: "",
                    source: QX7Rule.enabled ? this.QX7 : this.CUSTOMIZER_BACKEND
                },
                // Color Information
                color: {
                    id: 0,
                    name: "",
                    source: QX7Rule.enabled ? this.QX7 : this.CUSTOMIZER_BACKEND
                },
                // Pattern Information
                pattern: {
                    id: 0,
                    name: "",
                    colors: [],
                    source: this.CUSTOMIZER_BACKEND,
                    color_source: QX7Rule.enabled ? this.QX7 : this.CUSTOMIZER_BACKEND
                },

                // Selection Array
                pattern_selections: [],
                fabric_selections: [],

                // Angle Information
                angle: [],
            }

            let materialOptionCode = label.fullname ?? label.code;

            let materialSettings = this.getSettingByCode(materialOptionCode);

            if (_.isUndefined(materialSettings)) return;

            let patternSettings = materialSettings.pattern;
            let colorObject = materialSettings.colorObj;
            let fabric = this.getFabricInformation();
            let angleData = this.getAngle(materialOptionCode.toTitleCase());

            // Set Angle Information
            part.angle = angleData;
            
            // Set Fabric
            if (!_.isUndefined(fabric)) {
                part.fabric.id = +fabric.id;
                part.fabric.name = +fabric.id;

                part.fabric_selections.push({
                    fabric_id: +fabric.id,
                    fabric_name: fabric.name
                })
            }

            if (!_.isUndefined(patternSettings) && !_.isUndefined(patternSettings.pattern_obj)) {
                let patternObject = patternSettings.pattern_obj;
                
                if (patternObject.name.toLowerCase() !== "blank") {
                    // Change type
                    part.type = "pattern";
                    // Set Pattern 
                    part.pattern.id = +patternObject.pattern_id;
                    part.pattern.name = patternObject.name;

                    let patternColors = [];
                    
                    // Extract color ID
                    _.each(patternObject.layers, layer => {
                        if (!_.isUndefined(layer.colorObj)) {
                            patternColors.push(+layer.colorObj.id);
                        }
                    });

                    // Set Pattern Layers colors
                    part.pattern.colors = patternColors;

                    // Add pattern
                    part.pattern_selections.push({
                        pattern_id: +patternObject.pattern_id,
                        pattern_name: patternObject.name
                    })
                }
            }

            if (typeof colorObject !== "undefined") {
                part.color.id = +colorObject.id;
                part.color.name = colorObject.name;
                
                let colorSelections = teamColors;
                let limitedColorSet = this.getLimitedColors(label.name);
                
                if (_.size(label.colors) > 0)
                    colorSelections = this.colorExtractor(label.colors);

                if (typeof limitedColorSet !== "undefined") {
                    colorSelections = this.colorExtractor(limitedColorSet);
                }

                part.color_selections = colorSelections
            }
            
            part_info.push(part);
        })

        settings.part_info = {
            team_color: teamColors,
            parts_info: part_info
        }

        if (ub.config.blockPattern === 'Stock Sideline Quarter Zip') {
            settings.part_info.parts_info.push({
                "part": "Body",
                "type": "color",
                "fabric": {
                    "id": 149,
                    "name": 149,
                    "source": "qx7"
                },
                "color": {
                    "id": ub.current_material.settings.upper.Body.colorObj.id,
                    "name": ub.current_material.settings.upper.Body.colorObj.color_alias,
                    "source": "qx7"
                },
                "pattern": {
                    "id": 0,
                    "name": "",
                    "colors": [],
                    "source": "customizer_backend",
                    "color_source": "qx7"
                },
                "pattern_selections": [],
                "fabric_selections": [
                    {
                        "fabric_id": 149,
                        "fabric_name": "Heathered"
                    }
                ],
                "angle": [
                    {
                        "default": 0,
                        "translateAngle": 0,
                        "perspective": "back"
                    },
                    {
                        "default": 0,
                        "translateAngle": 0,
                        "perspective": "front"
                    },
                    {
                        "default": 0,
                        "translateAngle": 0,
                        "perspective": "left"
                    },
                    {
                        "default": 0,
                        "translateAngle": 0,
                        "perspective": "right"
                    }
                ],
                "color_selections": [
                    {
                        "color_id": ub.current_material.settings.upper.Body.colorObj.id,
                        "color_name": ub.current_material.settings.upper.Body.colorObj.color_alias
                    }
                ]
            })
        }

        if (ub.config.blockPattern === 'Lite') {
            var settingss = _.where(ub.current_material.settings.upper, {alpha: 1})
            _.each(settingss, function(e) {

            settings.part_info.parts_info.push({
                "part": "Body",
                "type": "color",
                "fabric": {
                    "id": PartInformation.getFabricInformation().id,
                    "name": PartInformation.getFabricInformation().id,
                    "source": "qx7"
                },
                "color": {
                    "id": e.colorObj.id,
                    "name": e.colorObj.name,
                    "source": "qx7"
                },
                "pattern": {
                    "id": 0,
                    "name": "",
                    "colors": [],
                    "source": "customizer_backend",
                    "color_source": "qx7"
                },
                "pattern_selections": [],
                "fabric_selections": [
                    {
                        "fabric_id": PartInformation.getFabricInformation().id,
                        "fabric_name": PartInformation.getFabricInformation().name
                    }
                ],
                "angle": [
                    {
                        "default": 0,
                        "translateAngle": 0,
                        "perspective": "back"
                    },
                    {
                        "default": 0,
                        "translateAngle": 0,
                        "perspective": "front"
                    },
                    {
                        "default": 0,
                        "translateAngle": 0,
                        "perspective": "left"
                    },
                    {
                        "default": 0,
                        "translateAngle": 0,
                        "perspective": "right"
                    }
                ],
                "color_selections": [
                    {
                        "color_id": '',
                        "color_name": ""
                    }
                ]
            })
                
            })
        }
    },

    getFabricInformation: () => {
        if (QX7Rule.enabled) {
            return QX7Rule.Fabrics.getDefaultFabricObject();
        }
    },

    colorExtractor: (colorList) => {
        let colors = [];

        _.each(colorList, color => {
            colors.push({
                color_id: +color.id,
                color_name: color.name
            });
        });
        
        return colors;
    },

    getAngle: (name) => {
        let angles = [];
        let materialOptions = _.filter(ub.current_material.materials_options, {name});

        if (_.size(materialOptions) > 0) {
            _.each(materialOptions, option => {
                let angle = option.angle ?? 0
                angles.push({
                    default: angle,
                    translateAngle: ub.funcs.translateAngle(angle),
                    perspective: option.perspective
                })
            })
        }

        return angles;
    },

    patternExtractor: (patternList) => {
        let patterns = [];

        _.each(patternList, pattern => {
            patterns.push({
                pattern_id: +pattern.id,
                pattern_name: pattern.name
            });
        });

        return patterns
    },

    getSettingByCode: (materialOptionCode) => {
        let type =  ub.current_material.material.type,
            uniformSettings = ub.current_material.settings[type];
        
        return _.find(uniformSettings, {code: materialOptionCode});
    },

    getLimitedColors: (labelName) => {
        let colorSet
        let limitedColorSet = ub.data.materialOptionWithLimitedColors.getLimitedColorSet(labelName);

        if (typeof limitedColorSet !== "undefined") {
            alternateColorSet = [];

            _.each(limitedColorSet.valid_colors, function (item) {
                alternateColorSet.push(ub.funcs.getColorByColorCode(item));
            });

            colorSet = alternateColorSet;
        }

        return colorSet
    }
}